import {ChangeDetectorRef, Component, Injector, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {PlayerBaseService} from '../../services/PlayerService/player.base.service';
import {Log, LogTag} from '../../services/Log';
import {concatMap, filter, merge, mergeWith, Observable, of, switchMap} from 'rxjs';
import {map, take} from "rxjs/operators";
import {RegDialogComponent} from "../reg-dialog/reg.dialog.component";
import {MatDialog} from "@angular/material/dialog";
import * as websocket from 'websocket';
import {PlayerPwaService} from "../../services/PlayerService/player.pwa.service";

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['../reg-dialog/reg.dialog.component.css', './login.component.css']
})

export class LoginComponent extends RegDialogComponent implements OnInit {

  @ViewChild('user', {static: false}) user;
  @ViewChild('password', {static: false}) password;
  @ViewChild('btnLogin', {static: false}) btnLogin;
  @ViewChild("popup", {read: TemplateRef}) popup: TemplateRef<any>;

  popDialog;

  client;
  regCode;

  userRemoteReg = true;

  constructor(protected injector: Injector, public dialog: MatDialog) {
    super(injector)
    this.playerService = injector.get('playerService');
    this.changeDetectorRef = this.injector.get(ChangeDetectorRef);
  }

  ngOnInit() {
  }

  loginFailDialog() {
    this.popDialog = this.dialog.open(this.popup, {width: '370px', height: '280px'});
  }

  passFocusSecondPass() {
    try {
      this.password.nativeElement.focus();
    } catch (e) {
    }
  }

  login(): Observable<any> {
    return merge(
      this.remoteRegister(),
      this.localRegister()
    ).pipe(
      take(1)
    );
  }

  localRegister(): Observable<any> {
    return this.click$.pipe(
      switchMap(r => {
        this.disableUI(true);
        const url1 = 'https://' + (this.playerService as PlayerBaseService).domain +
          '/WebService/html/login.ashx?user=' + this.user.nativeElement.value +
          '&password=' + this.password.nativeElement.value;
        return this.http.get(url1, {responseType: 'text'});
      }),
      map( a => JSON.parse(a) ),
      switchMap(data => {
        (this.playerService as PlayerPwaService).sceneId = data.sceneId;
        (this.playerService as PlayerBaseService).businessId = data.businessId;
        if ((this.playerService as PlayerBaseService).businessId === -1) {
          this.loginFailDialog();
          this.disableUI(false);
          return of(null);
        }
        return (this.playerService as PlayerBaseService).updateCustomerInfo();
      }),
      switchMap(res => {
        if (res == true) {
          (this.playerService as PlayerBaseService).data['user'] = this.user.nativeElement.value;
          (this.playerService as PlayerBaseService).data['pass'] = this.password.nativeElement.value;
          return of('login');
        } else {
          return of(null);
        }
      }),
      filter(res => {
        return (res != null);
      })
    );
  }

  get codeDigits(): string[] {
    if (this.regCode==null) {
      return [];
    }
    return this.regCode.split('');
  }

  remoteRegister(): Observable<any> {
    const obs$ = new Observable<any>(sub => {
      try {
        const url = 'wss://'+this.playerService.domain+'/Web/registerWebSocket.ashx';
        this.client = new websocket.w3cwebsocket(url);
      } catch (e) {
        debugger
      }

      this.client.onopen = () => {
        if (this.client.readyState === this.client.OPEN) {
          const requestCode = {
            command: "requestCode"
          }
          this.client.send(JSON.stringify(requestCode));
        }
      }

      this.client.onerror = (err) => {
        debugger
      };

      this.client.onclose = (a) => {
        debugger
      };

      this.client.onmessage = (e) => {
        const msg = JSON.parse(e.data);
        switch (msg.command)
        {
          case "reqCode":
            this.regCode = msg.code;
            this.changeDetectorRef.detectChanges();
            break;

          case "register":
            sub.next(msg);
            sub.complete();
            break;
        }
      };
    })

    return obs$.pipe(
      switchMap(data => {
        (this.playerService as PlayerPwaService).stationToken = data.stationToken;
        (this.playerService as PlayerBaseService).stationId = data.stationId;
        (this.playerService as PlayerPwaService).sceneId = data.sceneId;
        (this.playerService as PlayerBaseService).businessId = data.businessId;
        return (this.playerService as PlayerBaseService).updateCustomerInfo();
      }),
      switchMap( myData => {
        return (this.playerService as PlayerBaseService).saveStationInfo();
      })
    )
  }

  onClose() {
    this.popDialog.close();
  }

}
